import { render, staticRenderFns } from "./konsultasi.vue?vue&type=template&id=6d9a0491&"
import script from "./konsultasi.vue?vue&type=script&lang=js&"
export * from "./konsultasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCardActions,QFile,QIcon,QChatMessage,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCardActions,QFile,QIcon,QChatMessage})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
